var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_603_1396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_603_1396",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_603_1396",
    transform: "scale(0.005)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_603_1396",
    width: 200,
    height: 200,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABNdJREFUeJzt3cmOVFUcx/GfxMSIOATUpQomhOEt1B2J0ZUxkQdwnlAURV+DJzAOiUTFjQhudeGYYKImxhUbjUO6ZSEBXBRERThVt6qrzr33fD7JXVVX9b/OqW9XD1xuAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADjtSPJoSTHk5xO8leSC5WP9STvJ9m1wPPak+RYkj+XMN+ZJB8k2b3AfPTc9iTvJDmX+kFc7fg980WyJ8kfPZ6Pntuf5XxlXcbx3hzP71jP56PHDqb+i77LsTbHc1xl/OtzzEdP7U/9F/wqAllf8Yyjtqn2ACuyPcmR2kPM4eM57nNyw6dg9N5O/XeDrsevSXbO8Vx3ZfIDtHcQZrIj/f5t1eXHWpKjmS+OS3Zl8gP02grmZeAOZfomn0qyL8nmSjPWdluSbyKQJh3P9DhuqjZdfYvEIZAROJ3yBu+rN1p1i8YhkBGY9s9HWv226tYsHodARsAG/99GxdHq+o2KDf6vjYyjxfUbHRv8j65xvD7DxzBwNniiaxyvXbyf9Rs5GzyJ4+vMHsfhf93X+o1c6xvcNY5XL7t/6+s3ei1vcNc4XrnCY7S8fk1odYO3ZfE4MsP9GLgWN7hrHIcKj9Xi+jWltQ3uGsfLUx6vtfVrTksb3DWOl2Z4zJbWr0mtbPC2JF9l9jgOzvi4raxfs1rY4K5xvNjhsc8UHmeec+bpmbEHssw4ksl/Ene1xzq6+PjUNuZAusbxwhyfY3eufI77b1nstGB6YqyBbEvyZWaP48ACn+vSOe7r2Zhz5umRMQbSNY7n64zJEIwtkK3pFsdzdcZkKMYUSNc4nq0zJkMylkDEwVKMIZCucTxTZ0yGaOiBiIOlGnIgW5N8kdnjeLrOmAzZUAPpGsdTdcZk6IYYSNc4nqwzJmMwtEA2J/k8s8fxRJ0xGYuhBXI44mCFhhbIZ5ktjsdrDci4DC2QaWcEnk/y2Ipn2pvkw0zODXGd9JEZWiBHUo7j0RXPszdXvu6666SPxNACuTOT6xP2IY5k8s5xtbVznfQRGFogyeSr9ieZRHEhyfdJHqw0S+mU29FfJ/2a2gOswLQI+rwGNya5LskvFWcY8votbNRP7qKmN3gDNL1+m2oPAH0mECgQCBQIBAoEAgUCgQKBQIFAoEAgUCAQKBAIFAgECgQCBQKBAoFAgUCgQCBQIBAoEAgUCAQKBAIFAoECgUCBQKBAIFAgECgQCBQIBAoEAgUCgYIWAjk35fbrVzLFMG2ZcvvZlUxRUQuB/Dzl9ntXMsUw3Tfl9mlrywCcSPkSbN8mubnadP11S5LvUl67j6pNtyItvIOcnHL77iSfJrk/yQ3LH6f3tiR5IJPrte+c8rEnlj9OXaO+fNZFO5L8kDa+GKzS+SR3J/mp8hxL1cKL5sck79YeYoTeysjjaMn2TC5ZPO2S0I7ZjrUkd3TaAXpvf+q/sMZyPNxx7RmIg6n/4hr6caDzqjMoj8S3W/Mca/HO0Yy7kryZyV/Za7/w+n6cS/JGGv2Zo4Vf85ZsT/JQknuS7E1ye5Jrq05U39lM/kJ+KpO/c/htFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACj9Tdfeuioey5p6gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.8870657065da9973451e2d1c613b6aad.svg";
export { ForwardRef as ReactComponent };